import React, { useState, memo } from 'react';
import hash from 'object-hash';

import Cookies from 'universal-cookie';
import { addDays } from 'utils/date';
import { setCookie } from 'utils/cookie';
import { Banner } from './Banner';

const cookies = new Cookies();

const URGENCY_BANNER_DAYS_TO_SHOW_AGAIN = 5; // days
export const URGENCY_BANNER_COOKIE = 'wtr_cookie_urgency_banner';

export interface UrgencyBannerProps {
  html?: string;
  type: 'info' | 'warning' | 'danger';
}

const UrgencyBanner = ({ html, type }: UrgencyBannerProps) => {
  const hashValue = hash(html + type);
  const cookieValue = cookies.get(URGENCY_BANNER_COOKIE);

  const [show, setShow] = useState(!(cookieValue === hashValue));

  const close = () => {
    setShow(false);

    setCookie(URGENCY_BANNER_COOKIE, hashValue, {
      expires: addDays(new Date(), URGENCY_BANNER_DAYS_TO_SHOW_AGAIN),
    });
  };

  if (!show || !html) return null;

  return (
    <Banner type={type} onClose={close}>
      {{ __html: html }}
    </Banner>
  );
};

UrgencyBanner.displayName = 'UrgencyBanner';

export default memo(UrgencyBanner);
